import React, { useEffect } from "react";
import Header from "../components/Header.jsx";
import Footer from "../components/Footer.jsx";
import Preloader from "../components/Preloader.jsx";
import ScrollToTop from "../components/ScrollToTop.jsx";
import WhatsappBtn from "../components/WhatsappBtn.jsx";

export default function Layout({ children }) {
  useEffect(() => {
    const preloader = document.getElementById("preloader");

    // small delay to ensure DOM is ready
    const timer = setTimeout(() => {
      if (preloader) {
        preloader.style.opacity = "0";
        preloader.style.transition = "0.4s ease";

        setTimeout(() => {
          preloader.remove();
        }, 400); // match fade-out duration
      }
    }, 500);

    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      <Preloader />
      <Header />

      {/* Page-specific content goes here */}
      {children}

      <Footer />
      <ScrollToTop />
      <WhatsappBtn />
    </>
  );
}
